export const GET_KEY_PICKUP_DROP_VISIT_REQUEST = 'GET_KEY_PICKUP_DROP_VISIT_REQUEST';
export const GET_KEY_PICKUP_DROP_VISIT_SUCCESS = 'GET_KEY_PICKUP_DROP_VISIT_SUCCESS';
export const GET_KEY_PICKUP_DROP_VISIT_FAILURE = 'GET_KEY_PICKUP_DROP_VISIT_FAILURE';

export const GET_KEY_PICKUP_DROP_VISIT_LOCATION_REQUEST = 'GET_KEY_PICKUP_DROP_VISIT_LOCATION_REQUEST';
export const GET_KEY_PICKUP_DROP_VISIT_LOCATION_SUCCESS = 'GET_KEY_PICKUP_DROP_VISIT_LOCATION_SUCCESS';
export const GET_KEY_PICKUP_DROP_VISIT_LOCATION_FAILURE = 'GET_KEY_PICKUP_DROP_VISIT_LOCATION_FAILURE';
